import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const InputStyled = css`
  border-width: 2px;
  border-color: #e7e6e4;
  display: flex;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  width: 100%;
  font-weight: 500;
  font-size: 1rem;
  line-height: 120%;
  border-radius: 0.5rem;
  outline: none;
  box-shadow: none;

  ::placeholder,
  ::-webkit-input-placeholder {
    color: #a7a6a4;
    font-weight: 500;
  }

  :focus {
    border-color: #000000;
  }

  :-webkit-autofill,
  :-webkit-autofill:hover,
  :-webkit-autofill:focus,
  :-webkit-autofill:active {
    box-shadow: 0 0 0 1000px white inset;
  }

  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`

export const InputContainer = styled.div<{ isDisabled?: boolean; isError?: boolean; isSuccess?: boolean }>`
  &,
  label,
  p {
    ${({ isError }) => isError && 'color: #C62D2C;'}
    ${({ isSuccess }) => isSuccess && 'color: #08786C;'}
    ${({ isDisabled }) => isDisabled && 'color: #A7A6A4;'}
  }

  input,
  textarea,
  select {
    ${({ isError }) => isError && 'border-color: #EE533D; background-color: #FFE4DA;'}
    ${({ isSuccess }) => isSuccess && 'background-color: #D7F6E7; border-color: #08786C;'}
    ${({ isDisabled }) => isDisabled && 'background-color: #F3F3F2; border-color: #E7E6E4;'}
  }

  svg {
    color: #000000;
    position: absolute;
    width: 1rem;
    &:first-of-type {
      left: 1.25rem;
    }
    &:last-of-type {
      right: 1.25rem;
    }
    ${({ isDisabled }) => isDisabled && 'color: #A7A6A4;'}
  }
`
